export default {
    name: "Bitcoin Silver",
    coin: "BTCS",
    scheme: "SOLO",
    account: 'BjuafqLwWDi3hrwTHYSQSqichNHJRRTm1K',
    url: '',
    explorer_url: 'https://explorer.bitcoinsilver.top',
    coingecko: '',
    explorer: {
        address: 'https://explorer.bitcoinsilver.top/address/',
        height: 'https://explorer.bitcoinsilver.top/block/',
        hash: 'https://explorer.bitcoinsilver.top/block/',
        tx: 'https://explorer.bitcoinsilver.top/tx/',
    },
    ports: [
        {
            info: 'LOW',
            vardiff: true,
            host: 'molepool.com',
            port: 7101,
            diff: 262144,
        },
        {
            info: 'MID',
            vardiff: false,
            host: 'molepool.com',
            port: 7102,
            diff: 1048576,
        }
    ]
};